import axios from "axios";
import { URL } from "../config/config";

const initialState = {
  allPlans: {},
  isLoading: false,
  error: null,
};

const LOAD_START = "WhatsAppPaymentsPlan/LOAD_START";
const LOAD_SUCCESS = "WhatsAppPaymentsPlan/LOAD_SUCCESS";
const EDIT_PLAN = "WhatsAppPaymentsPlan/EDIT_PLAN";
const ADD_PLAN = "WhatsAppPaymentsPlan/ADD_PLAN";
const LOAD_FAILURE = "WhatsAppPaymentsPlan/LOAD_FAILURE";

const loadStart = () => ({
  type: LOAD_START,
});

const loadSuccess = (payload) => ({
  type: LOAD_SUCCESS,
  payload,
});

const editPlan = (payload) => ({
  type: EDIT_PLAN,
  payload,
});

const addPlan = (payload) => ({
  type: ADD_PLAN,
  payload,
});

const loadFailure = (error) => ({
  type: LOAD_FAILURE,
  payload: error,
});

export const fetchWhatsappPaymentsPlans = () => (dispatch, getState) => {
  const { user } = getState().login;
  if (user.isReferral) {
    return;
  }
  dispatch(loadStart());
  axios
    .get(URL + "/api/whatsapp-payments-plans")
    .then((response) => {
      const { whatsappPaymentsPlans } = response.data;
      const plansObj = {};
      for (const value of whatsappPaymentsPlans) plansObj[value._id] = value;
      dispatch(loadSuccess(plansObj));
    })
    .catch((error) => {
      console.error(error);
      dispatch(loadFailure(error));
    });
};

export const modifyWhatsappPaymentPlan = (payload) => (dispatch) => {
  dispatch(editPlan(payload));
};

export const addWhatsappPaymentPlan = (payload) => (dispatch) => {
  dispatch(addPlan(payload));
};

export default function PlanReducer(state = initialState, { type, payload }) {
  switch (type) {
    case LOAD_START:
      return { ...state, isLoading: true, error: null };

    case LOAD_SUCCESS:
      return {
        ...state,
        allPlans: { ...payload },
        isLoading: false,
        error: null,
      };

    case EDIT_PLAN:
      return {
        ...state,
        allPlans: {
          ...state.allPlans,
          [payload.id]: {
            ...state.allPlans[payload.id],
            slabs: payload.slabs,
          },
        },
        isLoading: false,
        error: null,
      };
    case ADD_PLAN:
      return {
        ...state,
        allPlans: {
          ...state.allPlans,
          [payload._id]: { ...payload },
        },
        isLoading: false,
        error: null,
      };
    case LOAD_FAILURE:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
}
